export default __webpack_public_path__ + "static/security-hog-0c97429e19e9f9c1831d503ae61cef16.png";